import { Injectable } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";
import { STORAGE_CUSTOMER_JWT } from "../constants";

@Injectable()
export class AuthService {
    constructor(private jwtHelper: JwtHelperService) {}

    public isAuthenticated(): boolean {
        const token = localStorage.getItem(STORAGE_CUSTOMER_JWT)
        return !this.jwtHelper.isTokenExpired(token)
    }
}